'use strict';
const angular = require('angular');

export class carouselMainComponent {
  constructor(SettingsService) {
    'ngInject';

    this.SettingsService = SettingsService;
  }

  $onInit() {

    let applyLocalConfig = () => {
      if (typeof this.heading !== 'undefined')
        this.vmHeading = this.heading;

      if (typeof this.subHeading !== 'undefined')
        this.vmSubHeading = this.subHeading;

      if (typeof this.slides !== 'undefined')
        this.vmSlides = this.slides;
    };

    if (this.settings) {

      let METHOD = this.public ? "getPublicByName" : "getByName";

      this.SettingsService[METHOD]({name: this.settings}, config => {
        this.vmHeading = config.data.heading;
        this.vmSubHeading = config.data.subHeading;
        this.vmSlides = config.data.slides;

        // overrides settings with local shortcode config
        applyLocalConfig();
      });

    } else {
      applyLocalConfig();
    }

  }
}

export default angular.module('conduuApp.carouselMain', [])
  .component('carouselMain', {
    template: require("./carouselMain.component.html"),
    bindings: {
      heading: '@',
      subHeading: '@',
      slides: '<',
      settings: '@',
      public: '<'
    },
    controller: carouselMainComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/carousel-main/carouselMain.component.js